// Components
import Svg from 'src/Components/shared/Svg'

export const BellSvg = props => (
  <Svg
    width='16'
    height='17'
    viewBox='0 0 16 17'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M16 10.7857V14.2143H10.2857C10.2857 15.4683 9.25397 16.5 8 16.5C6.74603 16.5 5.71429 15.4683 5.71429 14.2143H0V10.7857C0.888889 10.7857 2.28571 10.9603 2.28571 9.64286V6.21429C2.28571 3.05556 4.84127 0.5 8 0.5C11.2063 0.5 13.7143 3.18254 13.7143 6.35714V9.64286C13.7143 10.2778 14.2222 10.7857 14.8571 10.7857H16Z'
      fill='var(--brand-neutral-warm-500)'
    />
  </Svg>
)
